<template>
  <v-app id="v-app" class="h-100">
    <div class="topBar" style="margin-bottom: 48px">
      <topBar app></topBar>
    </div>

    <vue-progress-bar></vue-progress-bar>
    <transition name="fade" mode="out-in">
      <router-view :key="$router.fullpath"></router-view>
    </transition>
    <shortcuts></shortcuts>
  </v-app>
</template>


<script>
import axios from "axios";
import { eventBus } from "./main";
import { mapMutations } from "vuex";
import { getUserData } from "@/api";
import shortcuts from "@/components/shortcuts";
import topBar from "@/components/topBar";

export default {
  components: {
    topBar,
    shortcuts,
  },
  data() {
    return {};
  },
  methods: {
    ...mapMutations(["setUserData"]),
  },
  created() {
    let interval;
    let f = () => {
      try {
        this.setUserData(getUserData());
      } catch (err) {
        return;
      }
      clearInterval(interval);
    };
    interval = setInterval(f, 200);
  },
};
</script>

<style>
html,
body,
#app,
/* #v-app {
  height: 100%;
} */

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
#v-app .v-dialog .v-card {
  margin: 0;
}

#v-app .alertify {
  z-index: 200000000;
}
</style>